import EA from '../helpers/init';
import gsap from 'gsap';
import CustomEase from 'gsap/dist/CustomEase';

gsap.registerPlugin(CustomEase);

export default EA.Methods.heroAnim = ($this) => {
    const mm = gsap.matchMedia();

    mm.add('(min-width: 1201px', () => {
        const mediaStage = $this;
        const mediaItems = $this.querySelectorAll('.media-wrapper');
        const lines = $this.querySelectorAll('.hero-title-line');
        const btn = $this.querySelector('.btn-hero');
    
        gsap.set(btn, { autoAlpha: 0, yPercent: 60 });
        gsap.set(lines, { autoAlpha: 0, y: 64 });
        gsap.set(mediaItems, {
            autoAlpha: 0,
            yPercent: 200,
            z: 800,
            transformPerspective: 1200,
            transformOrigin: '50% 50%',
            force3D: true
        });
    
        const tl = gsap.timeline({
            defaults: {
                ease: new CustomEase('.6,0,.1,1'),
            }
        });
    
        tl.to(lines, {
            autoAlpha: 1,
            y: 0,
            duration: .7,
            stagger: 0.225,
            delay: 0.5,
        });
    
        tl.to(mediaItems, {
            ease: 'power4.out',
            autoAlpha: 1,
            xPercent: (i, el) => parseFloat(el.style.getPropertyValue('--xPercent')) || 0,
            yPercent: (i, el) => parseFloat(el.style.getPropertyValue('--yPercent')) || 0,
            x: (i, el) => parseFloat(el.style.getPropertyValue('--x')) || 0,
            y: (i, el) => parseFloat(el.style.getPropertyValue('--y')) || 0,
            z: (i, el) => parseFloat(el.style.getPropertyValue('--z')) || 0,
            duration: 2.25,
            stagger: 0.225
        }, '-=0.40');
    
        tl.to(btn, {
            ease: 'elastic.out(1,0.75)',
            autoAlpha: 1,
            yPercent: 0,
            duration: 1.5,
            clearProps: 'all',
        }, '-=0.60');
    
        let base = [];
        let nx = 0, ny = 0; // -1..1
        let rect = null;
    
        // Smooth setters (avoid spawning tweens on every move)
        const itemSetters = Array.from(mediaItems).map((el) => {
            const depth = parseFloat(el.dataset.depth || '1');
            return {
                el,
                depth,
                x: gsap.quickTo(el, 'x', { duration: 0.7, ease: 'power3.out' }),
                y: gsap.quickTo(el, 'y', { duration: 0.7, ease: 'power3.out' }),
            };
        });
    
        const updateRect = () => { rect = mediaStage.getBoundingClientRect(); };
    
        const onMove = (e) => {
            if (!rect) updateRect();
            const px = (e.clientX - (rect.left + rect.width / 2)) / (rect.width / 2);
            const py = (e.clientY - (rect.top + rect.height / 2)) / (rect.height / 2);
            nx = gsap.utils.clamp(-1, 1, px);
            ny = gsap.utils.clamp(-1, 1, py);
        };
    
        const onLeave = () => { nx = 0; ny = 0; };
    
        const tick = () => {
            // subtle per-item offsets layered on top of the base transform values
            itemSetters.forEach((s, i) => {
                const b = base[i];
                if (!b) return;
    
                const move = 0.1 * s.depth; // px
                s.x(b.x + nx * move);
                s.y(b.y + ny * move);
            });
        };
    
        const enableParallax = () => {
            updateRect();
            window.addEventListener('resize', updateRect, { passive: true });
            window.addEventListener('scroll', updateRect, { passive: true });
    
            mediaStage.addEventListener('pointermove', onMove, { passive: true });
            mediaStage.addEventListener('pointerleave', onLeave, { passive: true });
    
            gsap.ticker.add(tick); 
        };
    
        const disableParallax = () => {
            window.removeEventListener('resize', updateRect);
            window.removeEventListener('scroll', updateRect);
    
            mediaStage.removeEventListener('pointermove', onMove);
            mediaStage.removeEventListener('pointerleave', onLeave);
    
            gsap.ticker.remove(tick); 
        };
    
        // After images land, capture base transforms and enable parallax
        tl.add(() => {
            base = Array.from(mediaItems).map((el) => {
                const t = gsap.getProperty(el, 'x');
                const u = gsap.getProperty(el, 'y');
                return { x: +t || 0, y: +u || 0};
            });
            enableParallax();
        });
    });
};
